<div>
  <table mat-table [dataSource]="dataSource" matSort>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "view_value.meter_name" | translate }}
      </th>
      <td mat-cell *matCellDef="let row">{{ row.name ?? "-" }}</td>
    </ng-container>

    <!-- paremeter Column -->
    <ng-container matColumnDef="parameter">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "view_value.parameter" | translate }}
      </th>
      <td mat-cell *matCellDef="let row">{{ row.parameter ?? "-" }}</td>
    </ng-container>

    <!-- min_time Column -->
    <ng-container matColumnDef="min_time">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "view_value.min_time" | translate }}
      </th>
      <td mat-cell *matCellDef="let row">{{ row.min_time ?? "-" }}</td>
    </ng-container>

    <!-- min_val Column -->
    <ng-container matColumnDef="min_val">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "view_value.min_val" | translate }}
      </th>
      <td mat-cell *matCellDef="let row">{{ row.min_val ?? "-" }}</td>
    </ng-container>

    <!-- max_time Column -->
    <ng-container matColumnDef="max_time">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "view_value.max_time" | translate }}
      </th>
      <td mat-cell *matCellDef="let row">{{ row.max_time ?? "-" }}</td>
    </ng-container>

    <!-- max_val Column -->
    <ng-container matColumnDef="max_val">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "view_value.max_val" | translate }}
      </th>
      <td mat-cell *matCellDef="let row">{{ row.max_val ?? "-" }}</td>
    </ng-container>

    <!-- avg_val Column -->
    <ng-container matColumnDef="avg_val">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "view_value.avg_val" | translate }}
      </th>
      <td mat-cell *matCellDef="let row">{{ row.avg_val }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

    <!-- Row shown when there is no matching data. -->
    <!-- <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="4">No data</td>
    </tr> -->

    <tr class="mat-row no-data-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length">
        <div class="no-data-container">
          <mat-icon class="no-data-icon">inbox</mat-icon>
          <p>{{ "view_value.no_data" | translate }}</p>
        </div>
      </td>
    </tr>
  </table>

  <mat-paginator
    [pageSizeOptions]="[5, 10, 50, 100]"
    aria-label="Select page of users"
  ></mat-paginator>
</div>
